define(
    'viewmodels/secured/explorer/details/tabs/actions/BulkDownloadAction',[
        "viewmodels/secured/explorer/context",
        "viewmodels/secured/explorer/details/tabs/actions/Action",
        "services/service.dialog",
        "services/service.documents",
        "services/config",
        "i19n!i19n/strings"
    ],
    function (ctx, Action, dialogService, documentsService, config, i19n) {

        var BulkDownloadAction = (function (_super) {

            var _i19n = {
                action: {
                    name: i19n.to.bulkdownload,
                    message: i19n.to.bulkdownloadtheselecteddocuments
                },
                dialogoptions: {
                    ok: {
                        label: i19n.to.okay,
                        message: i19n.to.bulkdownloadtheselecteddocuments
                    },
                    cancel: {
                        label: i19n.to.cancel,
                        message: i19n.to.cancel
                    }
                }
            };

            __extends(_Action, _super);

            function _Action(context, disableFilters, hideFilters) {
                _super.call(this, _i19n.action, "fa-download", context, disableFilters, hideFilters);

                this.command = Action.getCommand(this, { execute: execute });
            }

            function execute(action, complete) {
                var documents = action.context.checkedDocuments();

                _.map(documents, function (itm) {
                    setTimeout(function () {
                        var url = String.format("{0}documents/instancecontent/{1}/{2}", config.webApiUrl, config.instanceCode, itm.documentId);

                        window.open(url, "id" + itm.documentId, "", true);

                        //var theAnchor = $('<a />').attr('href', url).attr('id', itm.documentId).appendTo('body');

                        //theAnchor[0].click();
                        //theAnchor.remove();
                    }, 100);
                    
                });
                
                complete();
            }

            return _Action;

        })(Action);

        return BulkDownloadAction;

    });
